export const data = {
  computedStack: [],
  trackerSymbol: Symbol('tracker')
}
